import { Dropdown } from "primereact/dropdown";
import { useCallback } from "react";
import { useForm, Controller } from "react-hook-form";
import { InputText } from "primereact/inputtext";
import styles from "../components/ObligationsJournal/style.module.scss";

const MONTHS = [
    { label: "Январь", value: 1 },
    { label: "Февраль", value: 2 },
    { label: "Март", value: 3 },
    { label: "Апрель", value: 4 },
    { label: "Май", value: 5 },
    { label: "Июнь", value: 6 },
    { label: "Июль", value: 7 },
    { label: "Август", value: 8 },
    { label: "Сентябрь", value: 9 },
    { label: "Октябрь", value: 10 },
    { label: "Ноябрь", value: 11 },
    { label: "Декабрь", value: 12 },
];

const OP_TYPES = [
    { label: "Начисление", value: "Начисление" },
    { label: "Удержание", value: "Удержание" },
    { label: "Корректировка", value: "Корректировка" },
];

const defaultValues = {
    obligation_id: "",
    operation_type: null,
    tax_type_id: "",
    tax_type_name: "",
    driver_id: "",
    driver_iin: "",
    executor_name: "",
    month: null,
    year: "",
};

const Field = ({ label, children }) => (
    <div className={styles.field}>
        <label className={styles.label}>{label}</label>
        {children}
    </div>
);

const useObligationsSearchForm = () => {
    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm({
        defaultValues,
        mode: "onSubmit",
        reValidateMode: "onSubmit",
        shouldFocusError: true,
    });

    const renderInput = useCallback(
        (name, placeholder) => (
            <Controller
                name={name}
                control={control}
                render={({ field }) => (
                    <InputText {...field} className={styles.input} placeholder={placeholder} />
                )}
            />
        ),
        [control]
    );

    const renderDropdown = useCallback(
        (name, placeholder, options) => (
            <Controller
                name={name}
                control={control}
                render={({ field }) => (
                    <Dropdown
                        {...field}
                        value={field.value}
                        options={options}
                        optionLabel="label"
                        optionValue="value"
                        placeholder={placeholder}
                        className={styles.input}
                        showClear
                    />
                )}
            />
        ),
        [control]
    );

    const searchForm = useCallback(
        (actions) => (
            <div className={styles.searchGrid}>
                <Field label="ID обязательства">{renderInput("obligation_id", "Введите ID")}</Field>
                <Field label="Тип операции">{renderDropdown("operation_type", "Выберите тип", OP_TYPES)}</Field>
                <Field label="ID вида налога/платежа">{renderInput("tax_type_id", "Введите ID")}</Field>
                <Field label="Наименование вида налога/платежа">
                    {renderInput("tax_type_name", "Введите наименование")}
                </Field>
                <Field label="ID водителя">{renderInput("driver_id", "Введите ID")}</Field>

                <Field label="ИИН водителя">{renderInput("driver_iin", "Введите ИИН")}</Field>
                <Field label="ФИО водителя">{renderInput("executor_name", "Введите ФИО")}</Field>
                <Field label="Месяц расчета">{renderDropdown("month", "Выберите месяц", MONTHS)}</Field>
                <Field label="Год расчета">{renderInput("year", "Введите год")}</Field>

                <div className={styles.actionsCell}>{actions}</div>

                {!!Object.keys(errors || {}).length && (
                    <div className={styles.formError}>Проверьте корректность заполнения полей.</div>
                )}
            </div>
        ),
        [errors, renderDropdown, renderInput]
    );

    return { searchForm, handleSubmit, reset };
};

export default useObligationsSearchForm;